import sendMonitoringEvent from '@/modules/monitoring/sendEvent';
import { getUserType } from '@/modules/userUtils';

export function getAnalyticsUserData(globalContext, studentContext) {
  try {
    const { user, availableLanguages } = globalContext;
    const { subscription: studentSubscription } = studentContext;

    const userData = {
      userType: null,
      subscriptionType: null,
      userLanguage: availableLanguages?.toString(),
      status: null,
      trial: null,
    };

    const userType = getUserType(user);

    if (user) {
      userData.userType = userType;

      if (userType == 'student') {
        if (studentSubscription) {
          userData.subscriptionType = studentSubscription.subscriptionType.code;
          userData.trial = studentSubscription.trial;
          userData.status = studentSubscription.status;
        }
      } else if (userType == 'teacher') {
        const subscription = user.teacher.subscription;
        userData.subscriptionType = subscription?.subscriptionType?.code;
        userData.trial = subscription?.trial;
        userData.status = subscription?.status;
      }
    }
    return userData;
  } catch (err) {
    sendMonitoringEvent({
      type: 'PLAUSIBLE_EVENT_ERROR',
      data: {
        pathname: window.location.pathname,
        search: window.location.search,
        eventData: {
          enventMame: 'Problem getting userData',
          handler: 'getAnalyticsUserData',
        },
        errorInfo: {
          message: err.message,
          name: err.name,
        },
      },
      result: 'error',
    });
    return {};
  }
}

export function getAnalyticsActivityProps(activity, activityConf) {
  const activityType = activity.type;
  const activitySubType = activity?.data?.subType ?? activity.type;
  const miniactivityType = activityConf?.miniactivityType ?? activitySubType;
  const level = activityConf?.level ?? 'default';
  const mode = activityConf?.mode ?? 'default';
  const seoProps = {
    title: activity.englishName,
    activityType,
    activitySubType,
    miniactivityType,
    difficulty: level.toLowerCase(),
    mode,
  };
  return seoProps;
}

export function sendAnalyticsErrorEvent(eventData, err) {
  sendMonitoringEvent({
    type: 'PLAUSIBLE_EVENT_ERROR',
    data: {
      pathname: window.location.pathname,
      search: window.location.search,
      eventData,
      errorInfo: {
        message: err.message,
        name: err.name,
      },
    },
    result: 'error',
  });
}
